<template>
  <div v-if="!isCustomizingDates">
    <button
        class="badge badge-light pointer py-1 mx-1"
        v-for="option in options"
        :key="option.value"
        variant="light"
        :class="{ active: type === option.value }"
        @click="$emit('changeType', { type: option.value })"
    >
      {{ option.label }}
    </button>
    <button class="badge badge-light py-1 pointer" variant="light" @click="toggleDateCustomization">Personalizado</button>
  </div>
  <span v-else class="d-flex">
    <input
        type="text"
        class="form-control form-sm me-2"
        placeholder="De dd/mm/AAAA"
        id="startFilter"
        v-maska="'##/##/####'"
    />
    <input
        type="text"
        class="form-control form-sm me-2"
        placeholder="Até dd/mm/AAAA"
        id="endFilter"
        v-maska="'##/##/####'"
    />
    <button
        class="btn btn-sm btn-success  my-auto pointer me-2"
        title="Buscar"
        @click="applyCustomDates"
    >
    <font-awesome-icon
        :icon="['fa', 'fa-check']"
        class="clickable"
    />
    </button>
    <button
        class="btn btn-sm btn-danger  my-auto pointer"
        @click="toggleDateCustomization"
        title="Cancelar"
    >
    <font-awesome-icon
        :icon="['fa', 'fa-ban']"
        class="clickable"
    />
    </button>
  </span>
</template>

<script>
export default {
  props: ["type"],
  data() {
    return {
      isCustomizingDates: false, // Controla se está personalizando as datas
      options: [
        { label: "24 horas", value: 1 },
        { label: "7 dias", value: 2 },
        { label: "1 mês", value: 3 },
      ],
    };
  },
  methods: {
    toggleDateCustomization() {
      this.isCustomizingDates = !this.isCustomizingDates;
    },
    applyCustomDates() {
      const start = document.getElementById("startFilter").value;
      const end = document.getElementById("endFilter").value;
      this.$emit("changeType", {
        type: 4,
        start,
        end,
      });
      this.isCustomizingDates = false; // Fecha o modo de personalização após aplicar
    },
  },
};
</script>
